export default __webpack_public_path__ + "static/media/info09_Capsula_de_induccion.b56b57b6.png";